import React from 'react';
import { motion } from 'framer-motion';
export function ExplanationSection() {
  return <section className="bg-navy text-cream py-24 px-5" data-id="element-27">
      <div className="max-w-3xl mx-auto text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8 font-dmsans text-lg md:text-xl text-cream/80" data-id="element-29">
          <p data-id="element-30">
            Nadie nos enseña a comunicar{' '}
            <span className="text-gold font-bold" data-id="element-31">valor</span>. Aprendemos a
            ofrecer viajes, destinos y datos técnicos, pero fallamos en
            comunicar esto último.
          </p>
          <p data-id="element-32">
            El error más común es mandar un precio en lugar de presentar una
            propuesta. Cuando solo mandás números, el cliente solo compara
            números.
          </p>
          <p data-id="element-33">
            Falta estructura. Falta un método para{' '}
            <span className="text-gold font-bold" data-id="element-34">cerrar</span>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-12" data-id="element-35">
          <a href="#oferta" className="inline-block w-full md:w-auto bg-transparent border border-gold text-gold font-dmsans font-bold text-lg py-4 px-10 rounded hover:bg-gold hover:text-navy transition-all duration-300" data-id="element-36">
            Quiero aprender a cerrar más
          </a>
        </motion.div>
      </div>
    </section>;
}